export interface ISort {
  sortBy: string
  sortDirection: number
}

const SORT_DIRECTION_DESC = -1

export const getSortString = (sortBy: string, sortDirection: number) => {
  return `${sortDirection === SORT_DIRECTION_DESC ? '-' : ''}${sortBy}`
}
